export const PRESETS: Record<string, Record<string, string>> = {
  YouTube: {
    utm_source: 'youtube',
    utm_medium: 'video',
    utm_campaign: '{campaign}',
    utm_adgroup: '{adgroup}',
  },
  Meta: {
    utm_source: 'meta',
    utm_medium: 'social',
    utm_campaign: '{campaign}',
    utm_adgroup: '{adgroup}',
  },
  Preroll: {
    utm_source: 'preroll',
    utm_medium: 'video',
    utm_campaign: '{campaign}',
    utm_adgroup: '{adgroup}',
  },
};

export const ALL_WILDCARDS = ['campaign', 'adgroup'];
